import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import moment from 'moment';
import { getPre7DayParams } from '@blade-sxp/portrait-center/utils/index';
import Indicators from '@blade-sxp/portrait-center/pages/components/data-view/indicators.vue';
import Dougnuts from '@blade-sxp/portrait-center/pages/components/dougnuts/index.vue';
import LineBars from '@blade-sxp/portrait-center/pages/components/line-bars/index.vue';
import ExportTable from '@blade-sxp/portrait-center/pages/components/data-view/export-table.vue';
import zoneSelect from '@blade-sxp/portrait-center/components/zone-select.vue';
import zoneSelectVirtual from '@blade-sxp/portrait-center/components/zone-select-virtual.vue';
const API_NUM = 10; // 当前接口请求总数量
const DateRange = 180;
let dataView = class dataView extends Vue {
    form = {
        dates: this.getDafaultDates(),
    };
    get zoneType() {
        return PortraitCenterModule.activeTab;
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get apiRequestNum() {
        return PortraitCenterModule.apiRequestNum >= API_NUM; // 接口数量
    }
    pickerOptions = {
        disabledDate: (date) => moment(date).isAfter(moment().format('YYYY-MM-DD 00:00:00')),
    };
    onChangeDates() {
        this.onSearchClick();
        PortraitCenterModule.updateApiRequestNum(0);
    }
    onChangeZoneType() {
        this.onSearchClick();
        if (this.zoneType === 'VIRTUAL_AREA') {
            PortraitCenterModule.getVirtualZoneTagTree();
        }
        else if (this.zoneType === 'MAP') {
            PortraitCenterModule.getFetchZoneTree();
        }
    }
    mounted() {
        this.onSearchClick();
    }
    getDafaultDates() {
        const { dateStart, dateEnd } = getPre7DayParams(false);
        return [dateStart, dateEnd];
    }
    onResetClick() {
        if (this.zoneType === 'MAP') {
            PortraitCenterModule.getFetchZoneTree();
        }
        else if (this.zoneType === 'VIRTUAL_AREA') {
            PortraitCenterModule.getVirtualZoneTagTree();
        }
        this.form.dates = this.getDafaultDates();
    }
    onSearchClick() {
        const [dateStart, dateEnd] = this.form.dates;
        if (moment(dateEnd).isAfter(moment(dateStart).add(DateRange - 1, 'day'))) {
            this.$elmessage.error(this.$t('dateRangeError', { DateRange: DateRange }).toString());
            this.form.dates = this.getDafaultDates();
        }
        PortraitCenterModule.getFuncClusterVisitorType();
    }
};
__decorate([
    Watch('form.dates')
], dataView.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneType')
], dataView.prototype, "onChangeZoneType", null);
dataView = __decorate([
    Component({
        name: 'dataView',
        components: { Indicators, Dougnuts, LineBars, ExportTable, zoneSelect, zoneSelectVirtual },
        i18n: { messages: lang },
    })
], dataView);
export default dataView;
